import { VisitCardAPI } from "@/api/visit_card_generated/Api"
import type { API } from "@/api/client"

export * from "@/api/visit_card_generated/Api"

/**
 * Создаёт VisitCardAPI с тем же baseURL и credentials что у основного API.
 * HTTP-запросы идут на api_front (через тот же baseURL что у `api`),
 * который проксирует их на visit_card_service по совпадающим путям.
 */
export function createVisitCardApi(api: API<unknown>): VisitCardAPI<unknown> {
    const baseURL = api.instance.defaults.baseURL ?? ""
    return new VisitCardAPI({
        baseURL,
        withCredentials: true,
    })
}
